import { generatePath } from 'react-router-dom'

import { ITEM_SET, ITEM_SET2 } from '@core/constants/content-type'

export const LOGIN_ROUTE = '/'
export const AUTHOR_ROUTE = '/author'

export const AUTHOR_V2_ROUTE = '/author-v2'
export const AUTHOR_V2_LANDING_PAGE = '/author/landing-page'
export const AUTHOR_V2_CREATE = '/author/create'
export const AUTHOR_V2_RECENT_WORK_BASE = '/author/recent-work'
export const AUTHOR_V2_RECENT_WORK = `${AUTHOR_V2_RECENT_WORK_BASE}/:mode?`
export const AUTHOR_V2_ITEM_ROUTE = '/author-v2/:itemIdentifier'
export const AUTHOR_V2_ERROR = '/author-v2/error/:status'

export const AUTHOR_ITEM_ROUTE = '/author/item/:itemId'
export const AUTHOR_CLOZE_ROUTE = '/author/cloze/:itemId'
export const AUTHOR_ITEM_SET = '/author/item-set/:itemId'
export const USERS_ROUTE = '/users'
export const NOT_FOUND = '/404'
export const MY_FOLDERS_DRAFT_ITEMS = '/my-folders/draft-items'
export const MY_FOLDERS_DRAFT_ITEM_ROUTE = '/my-folders/item/:identifier'
export const INTERNAL_CUSTOMERS_ROUTE = '/internal/customers'
export const MY_FOLDERS_ROUTE = '/my-folders'
export const MY_FOLDER_ROUTE = '/my-folders/:folderId'
export const MY_FOLDER_ITEM_ROUTE = '/my-folders/:folderId/item/:itemId'

export const routeMap = {
  LOGIN_ROUTE,
  LOGIN_SSO_ROUTE: '/login/sso',
  AUTHOR_ROUTE,
  AUTHOR_V2_ROUTE,
  AUTHOR_V2_ITEM_ROUTE,
  AUTHOR_ITEM_ROUTE,
  AUTHOR_CLOZE_ROUTE,
  AUTHOR_ITEM_SET,
  NOT_FOUND,
  INTERNAL_CUSTOMERS_ROUTE,
  USERS_ROUTE,
  MY_FOLDERS_DRAFT_ITEMS,
  MY_FOLDERS_DRAFT_ITEM_ROUTE,
  AUTHOR_V2_LANDING_PAGE,
  AUTHOR_V2_RECENT_WORK,
  AUTHOR_V2_RECENT_WORK_BASE,
  MY_FOLDERS_ROUTE,
  MY_FOLDER_ROUTE,
  MY_FOLDER_ITEM_ROUTE,
  AUTHOR_V2_CREATE,
  AUTHOR_V2_ERROR,
} as const

export const getItemAuthorRoute = (item: {
  identifier: string
  batchId: string
  contentType: string
  id: string
  modelInfo: {
    type?: string
    id?: string
    profileKey?: string
  }
}) => {
  if (item.modelInfo?.type === 'profile' && item.batchId && item.identifier) {
    return generatePath(AUTHOR_V2_ITEM_ROUTE, {
      itemIdentifier: item.identifier,
    })
  }
  // If modelInfo.type isn't 'profile', we assume it's a v1 ('aimodel') Item
  const route = {
    [ITEM_SET]: AUTHOR_CLOZE_ROUTE,
    [ITEM_SET2]: AUTHOR_ITEM_SET,
  }
  return generatePath(route[item.contentType] || AUTHOR_ITEM_ROUTE, { itemId: item.id })
}

export const getAuthorCreateRoute = (profileKey: string, step: number) => {
  return `${AUTHOR_V2_CREATE}?profileKey=${profileKey}&step=${step}`
}

export type Route = (typeof routeMap)[keyof typeof routeMap]
